/* #203 extracted from theme.liquid — static-JS blocks load with defer */
(function(){
  /* Prevent href="#" from scrolling to top on cart popup buttons */
  document.addEventListener('click', function(e){
    var link = e.target.closest('#cart-message a[href="#"]');
    if (link) e.preventDefault();
  });

  /* Deferred-section hydrator — only runs on the homepage (gated by data attribute on <body>) */
  if (!document.body.dataset.deferSections) return;

  var main = document.getElementById('main-content');
  if (!main) return;
  var vh = window.innerHeight;
  var sections = main.querySelectorAll(':scope > .shopify-section');
  var deferred = [];

  for (var i = 0; i < sections.length; i++) {
    var s = sections[i];
    var top = s.getBoundingClientRect().top;
    if (top <= vh * 3) continue;
    var count = s.querySelectorAll('*').length;
    if (count > 200) {
      var h = s.getBoundingClientRect().height;
      var tpl = document.createElement('template');
      while (s.firstChild) tpl.content.appendChild(s.firstChild);
      s.appendChild(tpl);
      s.style.minHeight = Math.max(h, 200) + 'px';
      s.dataset.deferred = 'pending';
      deferred.push(s);
    }
  }

  if (!deferred.length) return;

  function hydrate(el) {
    if (el.dataset.deferred !== 'pending') return;
    el.dataset.deferred = 'loading';
    var sid = el.id.replace('shopify-section-', '');
    fetch(location.pathname + '?sections=' + sid)
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data[sid]) {
          var doc = new DOMParser().parseFromString(data[sid], 'text/html');
          var fresh = doc.querySelector('#' + CSS.escape(el.id));
          if (fresh) {
            fresh.querySelectorAll('img').forEach(function(img){
              img.loading = 'lazy';
              img.removeAttribute('fetchpriority');
            });
            while (el.firstChild) el.removeChild(el.firstChild);
            while (fresh.firstChild) el.appendChild(fresh.firstChild);
            el.querySelectorAll('script').forEach(function(old){
              if (old.type && old.type !== 'text/javascript' && old.type !== 'module') return;
              var s = document.createElement('script');
              if (old.src) s.src = old.src; else s.textContent = old.textContent;
              old.replaceWith(s);
            });
          }
        }
        el.style.minHeight = '';
        el.dataset.deferred = 'loaded';
      })
      .catch(function(err){
        console.warn('[deferred-section] hydration failed for', sid, err);
        var tpl = el.querySelector(':scope > template');
        if (tpl) {
          while (tpl.content.firstChild) el.insertBefore(tpl.content.firstChild, tpl);
          tpl.remove();
        }
        el.style.minHeight = '';
        el.dataset.deferred = 'loaded';
      });
  }

  function checkScroll() {
    if (window.scrollY < 10) return;
    var scrollBottom = window.scrollY + window.innerHeight + 800;
    deferred.forEach(function(s) {
      if (s.dataset.deferred !== 'pending') return;
      if (s.offsetTop < scrollBottom) hydrate(s);
    });
    if (deferred.every(function(s){ return s.dataset.deferred !== 'pending'; })) {
      window.removeEventListener('scroll', checkScroll);
    }
  }

  setTimeout(function(){
    window.addEventListener('scroll', checkScroll, { passive: true });
  }, 200);

  setTimeout(function(){
    deferred.forEach(function(s){ if (s.dataset.deferred === 'pending') hydrate(s); });
  }, 10000);
})();

/* Phone burger menu: keep the page where it was. The menu pins the body in place
   (position:fixed; top:0), which jumped the page to the top. Remember the scroll
   position, pin the body at that spot, and scroll back to it when the menu closes. */
(function(){
  var lastY = window.scrollY, savedY = 0, body = document.body;
  window.addEventListener('scroll', function(){
    if (!body.classList.contains('mobile-menu-active')) lastY = window.scrollY;
  }, { passive: true });
  new MutationObserver(function(){
    var open = body.classList.contains('mobile-menu-active');
    if (open && body.dataset.menuY === undefined) {
      savedY = lastY;
      body.dataset.menuY = savedY;
      body.style.top = -savedY + 'px';
    } else if (!open && body.dataset.menuY !== undefined) {
      delete body.dataset.menuY;
      body.style.top = '';
      window.scrollTo({ top: savedY, behavior: 'instant' });
    }
  }).observe(body, { attributes: true, attributeFilter: ['class'] });
})();
